import { request } from 'api/request';
import { PLATFORM_API_URLS } from 'api/constants';

export default class Utility {
  static getCdnImageUrl(search, config) {
    return request({
      url: PLATFORM_API_URLS.utility.getPresignedImageUrl,
      search,
      config,
    });
  }

  static customRequest(requestConfig) {
    return request(requestConfig);
  }
}
